<template>
  <div>
    <v-layout
      row
      align-center
    >
      <v-flex xs10 style="position: relative">
        <h3 :style="myTitleStyle">{{ itemName(item) }}</h3>
        <item-nutri-grade-tag :item="item" />
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
        :style="myPriceStyle"
      >
        {{ $n(itemPrice(item), 'currency') }}
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
        :style="myPresetDiscountPriceStyle"
        v-if="afterPresetDiscountPrice"
      >
        {{ $n(afterPresetDiscountPrice, 'currency') }}
      </v-flex>
    </v-layout>
    <div
      v-if="item.photo_url"
      class="mb-3 mt-2 text-xs-center"
      @click="showPicture = !showPicture"
    >
      <v-avatar
        :size="itemDetail.imgSize"
        tile
      >
        <v-img
          :src="item.photo_url"
          class="food-img"
        >
          <item-nutri-grade-tag :item="item" />
        </v-img>
      </v-avatar>
    </div>
    <div
      v-if="item.featured_icons && item.featured_icons.length > 0"
      class="mb-3"
    >
      <v-layout
        v-for="(featured, index) in item.featured_icons"
        :key="index"
        row
        align-center
        :class="index === item.featured_icons.length - 1 ? '' : 'mb-1'"
      >
        <v-avatar
          tile
          slot="activator"
          size="23px"
          class="mr-1"
        >
          <img class="feature-icon-img" :src="featured.img" />
        </v-avatar>
        <span
          :style="myTitleStyle"
          class="feature-icon-desc"
        >
          {{ featured.desc }}
        </span>
      </v-layout>
    </div>
    <div
      v-if="item.description"
      class="mb-4"
      :style="myDescStyle"
    >
      <span style="white-space: pre-wrap;">{{ item.description }}</span>
    </div>
    <div v-if="item.courses && item.courses.length > 0">
      <div
        v-for="(i1, index) in item.courses"
        :key="index"
        :id="i1.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()"
      >
        <h3
          class="title-name"
          :style="mySubTitleStyle"
        >
          {{ itemName(i1) }}
          <span
            v-if="completeFill(i1)"
            :style="noteStyle1"
          >({{ pleaseSelectMsg(i1) }})</span>
          <span
            v-else-if="i1.req_len && i1.course_items.length > 0"
            :style="noteStyle2"
          >({{ pleaseSelectMsg(i1) }})</span>
        </h3>
        <div
          v-for="i2 in i1.course_items"
          :key="i2.item_id"
          v-show="i2.item_id"
        >
          <v-layout
            row
            align-center
            class="option"
          >
            <v-flex xs8 sm10
                    v-if="parseInt(rid) === 941
                    && (parseFloat(i2.price_override) > 0 && i2.price && i2.price > i2.price_override)"
            >
              <v-radio-group
                v-if="i1.selector === 'radio'"
                v-model="i1.selected"
                @change="changeCourseItems(i2, i1)"
              >
                <v-radio
                  :value="i2.item_id"
                  :color="theme.checked_color"
                  :dark="dark"
                  :disabled="!itemAvailable(i2)"
                >
                  <template slot="label">
                    <span :style="mySubTitleStyle2(i2)">{{ itemName(i2) }}</span> <span style="color: grey" v-if="!itemAvailable(i2)">(Sold out)</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-checkbox
                v-else
                v-model="i1.selected"
                :value="i2.item_id"
                :color="theme.checked_color"
                @change="changeCourseItems(i2, i1)"
                :dark="dark"
                :multiple="i1.multiple"
                :disabled="!itemAvailable(i2)"
              >
                <template slot="label">
                  <span :style="mySubTitleStyle2(i2)">{{ itemName(i2) }}</span> <span style="color: grey" v-if="!itemAvailable(i2)">(Sold out)</span>
                </template>
              </v-checkbox>
            </v-flex>

            <v-flex xs10 v-else>
              <v-radio-group
                v-if="i1.selector === 'radio'"
                v-model="i1.selected"
                @change="changeCourseItems(i2, i1)"
              >
                <v-radio
                  :value="i2.item_id"
                  :color="theme.checked_color"
                  :dark="dark"
                  :disabled="!itemAvailable(i2)"
                >
                  <template slot="label">
                    <span :style="mySubTitleStyle2(i2)">{{ itemName(i2) }}</span> <span style="color: grey" v-if="!itemAvailable(i2)">(Sold out)</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-checkbox
                v-else
                v-model="i1.selected"
                :value="i2.item_id"
                :color="theme.checked_color"
                @change="changeCourseItems(i2, i1)"
                :dark="dark"
                :multiple="i1.multiple"
                :disabled="!itemAvailable(i2)"
              >
                <template slot="label">
                  <span :style="mySubTitleStyle2(i2)">{{ itemName(i2) }}</span> <span style="color: grey" v-if="!itemAvailable(i2)">(Sold out)</span>
                </template>
              </v-checkbox>
            </v-flex>

            <v-flex
              xs4 sm2
              text-xs-right
              :style="myCoursePriceStyle"
              v-if="parseInt(rid) === 941
                    && (parseFloat(i2.price_override) > 0 && i2.price && i2.price > i2.price_override)"
            >
              <span v-if="parseFloat(i2.price_override) > 0" style="font-size: smaller;"><del v-if="i2.price && i2.price > i2.price_override">(+{{ $n(i2.price, 'currency') }})</del> (+{{ $n(i2.price_override, 'currency') }})</span>
            </v-flex>
            <v-flex
              xs2
              text-xs-right
              :style="myCoursePriceStyle"
              v-else
            >
              <span v-if="parseFloat(i2.price_override) > 0">(+{{ $n(i2.price_override, 'currency') }})</span>
            </v-flex>

          </v-layout>
          <v-layout
            row
            align-center
          >
            <v-flex xs12>
              <course-detail
                v-if="i2.has_courses && checkSelectedItems(i1.selected, i2.item_id)"
                :course="i2"
              />
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
    <div>
      <v-dialog
        v-model="showPicture"
        persistent
        :fullscreen="iOS && inIframe"
        scrollable
        :max-width="imgWidth"
      >
        <v-img
          contain
          :src="item.photo_url"
          max-width="100%"
          width="auto"
          height="385px"
        >
          <v-layout>
            <v-spacer />
            <v-btn
              icon
              flat
              @click="showPicture = !showPicture"
              class="text-xs-right"
            >
              <v-icon :style="imgCloseStyle">close</v-icon>
            </v-btn>
          </v-layout>
        </v-img>
      </v-dialog>
    </div>
    <!-- <div v-if="item.option_groups && item.option_groups.length > 0">
      <div
        v-for="(i1, index) in item.option_groups"
        :key="index"
        :id="i1.name.replace(/\s+/g, '-').toLowerCase()"
      >
        <h3
          class="title-name"
          :style="mySubTitleStyle"
        >
          {{ (i1.name === 'Common M') ? 'Options' : itemName(i1) }}
          <span
            v-if="i1.req_len && checkRequired(i1.req_len, i1.max_len, i1.selected)"
            :style="noteStyle1"
          >({{ pleaseSelectMsg(i1) }})</span>
          <span
            v-else-if="i1.req_len"
            :style="noteStyle2"
          >({{ pleaseSelectMsg(i1) }})</span>
        </h3>
        <v-layout v-for="i2 in i1.options" :key="i2.option_id" :v-if="i2.is_non_modifier === 0" row align-center class="option">
        <v-layout
          v-for="i2 in i1.options"
          :key="i2.option_id"
          row
          align-center
          class="option"
          v-show="!i2.name.includes('Please Select')"
        >
          <v-flex xs10>
            <v-radio-group
              v-if="i1.selector === 'radio'"
              v-model="i1.selected"
              @change="changeModifiers"
            >
              <v-radio
                :value="i2.option_id"
                :color="theme.checked_color"
                :dark="dark"
              >
                <template slot="label">
                  <span :style="mySubTitleStyle">{{ itemName(i2) }}</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-checkbox
              v-else
              v-model="i1.selected"
              :value="i2.option_id"
              :color="theme.checked_color"
              @change="changeModifiers"
              :dark="dark"
            >
              <template slot="label">
                <span :style="mySubTitleStyle">{{ itemName(i2) }}</span>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex
            xs2
            :style="myPriceStyle"
          >
            <span v-if="parseFloat(i2.price) > 0">({{ $n(i2.price, 'currency') }})</span>
          </v-flex>
        </v-layout>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseDetail from '~/components/CourseDetail'
import ItemNutriGradeTag from '~/components/ItemNutriGradeTag'
import preset_discount from '../mixins/preset_discount'

export default {
  name: 'item-detail-component',
  components: {
    'course-detail': CourseDetail,
    'item-nutri-grade-tag': ItemNutriGradeTag
  },
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  data: () => {
    return {
      showPicture: false
    }
  },
  mixins: [preset_discount],
  computed: {
    ...mapGetters('config', [
      'theme', 'itemDetail', 'language', 'iOS', 'inIframe', 'rid', 'mode'
    ]),
    ...mapGetters('cart', [
      'pickupDate'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    dark () {
      return parseInt(this.theme.menu_theme) === 1
    },
    myTitleStyle () {
      return {
        color: this.theme.dialog_content_name_color
      }
    },
    imgCloseStyle() {
      console.log(this.theme);
      return {
        color: this.theme.img_close_btn_color
      }
    },
    mySubTitleStyle () {
      return {
        color: this.theme.dialog_content_name2_color
      }
    },
    myPriceStyle () {
      const styles = {
        color: this.theme.dialog_content_price_color
      }

      if (this.afterPresetDiscountPrice) {
        styles.textDecoration = 'line-through'
      }

      return styles;
    },
    myCoursePriceStyle () {
      return {
        color: this.theme.dialog_content_price_color
      }
    },
    myPresetDiscountPriceStyle () {
      return {
        paddingLeft: '6px',
        color: this.theme.dialog_content_price_color
      }
    },
    myQtyStyle () {
      return {
        color: this.theme.menu_qty_color
      }
    },
    myItemStyle () {
      return {
        color: this.theme.menu_color
      }
    },
    myDescStyle () {
      return {
        fontSize: '14px',
        color: this.theme.dialog_content_desc_color,
        fontWeight: 400
      }
    },
    noteStyle1 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_disabled_color
      }
    },
    noteStyle2 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_enabled_color
      }
      // return {
      //   fontWeight: 400,
      //   fontSize: 'smaller',
      //   color: 'white',
      //   textShadow: `-1px 0 ${this.theme.text_enabled_color}, 0 1px ${this.theme.text_enabled_color},
      //     1px 0 ${this.theme.text_enabled_color}, 0 -1px ${this.theme.text_enabled_color}`
      // }
    },
    imgWidth () {
      let img = new Image();
      img.src = this.item.photo_url;
      return img.width
    },
    afterPresetDiscountPrice () {
      const presetDiscount = this.calculateAvailablePresetDiscount(this.item, this.user, 1)

      if (!presetDiscount) {
        return null;
      }
      if (this.item && ((!this.item.set_course_items) || (this.item.set_course_items && this.item.set_course_items.length === 0))) {
        let price;
        if (this.item.final_price) {
          price = parseFloat(this.item.final_price)
          // return parseFloat(this.item.final_price) * this.item.quantity
        } else {
          price = parseFloat(this.item.price ? this.item.price : this.item.final_price);
          // return parseFloat(this.item.price ? this.item.price : this.item.final_price) * this.item.quantity
        }

        // if (presetDiscount) {
        //   this
        // }
        return presetDiscount
          ? this.calculateAfterPresetDiscountPriceByPrice(presetDiscount, price, 1)
          : (price * 1)
      } else if (this.item && this.item.set_course_items && this.item.set_course_items.length > 0){
        let item_price = 0
        if (this.item.final_price) {
          item_price = parseFloat(this.item.final_price)
        }
        item_price =  parseFloat(this.item.price ? this.item.price : this.item.final_price)

        this.item.set_course_items.forEach(function (i){
          item_price = item_price + parseFloat(i.price_override)
        })

        return presetDiscount
          ? this.calculateAfterPresetDiscountPriceByPrice(presetDiscount, item_price, 1)
          : (item_price * 1)
      }

      return 0
    },
  },
  methods: {
    completeFill (course) {
      return (course.req_len && this.checkRequired(course.req_len, course.max_len, course.selected))
        || (!course.req_len && course.max_len && course.course_items.length > course.max_len)
    },
    pleaseSelectMsg (course) {
      if (course.req_len && course.max_len && (course.req_len !== course.max_len)) {
        return this.$t('pls_select_1') + this.$t(course.req_len) + this.$t('to') + this.$t(course.max_len) + this.$t('pls_select_2')
      } else if (course.req_len) {
        return this.$t('pls_select_1') + this.$t(course.req_len) + this.$t('pls_select_2')
      } else if (course.max_len) {
        return this.$t('select_up_to') + this.$t(course.max_len) + this.$t('pls_select_2')
      }
    },
    checkRequired (reqLen, maxLen, selected) {
      if (!reqLen) {
        return true
      }
      if (reqLen === 1) {
        return Array.isArray(selected) ? selected.length >= reqLen : !!(selected)
      }
      return !!(selected && (!maxLen ? selected.length === reqLen : selected.length >= reqLen && selected.length <= maxLen))
    },
    changeCourseItems (i2, i1) {
      if ((Array.isArray(i1.selected) ? i1.selected.length : 1) > i1.max_len) {
        if (Array.isArray(i1.selected)) {
          const i = i1.selected.findIndex(i => i === i2.item_id)
          if (i !== -1) {
            i1.selected.pop()
          }
        } else {
          i1.selected = null
        }
      }
      if (i2.has_courses !== 1) {
        this.$store.dispatch('menu/processMenuItem', 'course')
      }
    },
    changeModifiers () {
      this.$store.dispatch('menu/processMenuItem', 'modifier')
    },
    checkSelectedItems (selected, item_id) {
      if (Array.isArray(selected)) {
        return selected.includes(item_id)
      }
      return selected == item_id
    },
    itemName (item) {
      if (this.language !== 'en-SG') {
        return item.alternate_name || item.alternativeName || item.name
      }
      return item.name
    },
    itemPrice (item) {
      return item.price_override || item.price
    },
    itemAvailable(i) {
      // const d2 = moment(this.pickupDate)
      // const today = moment()
      // if (!this.mode.isDinein && !(d2.isSame(today, 'day'))) return true
      return parseInt(i.is_enabled) === 1 && (i.inventory_left.toUpperCase() === 'NA'
        || parseInt(i.inventory_left) > 0)
    },
    mySubTitleStyle2 (i) {
      return {
        color: this.theme.dialog_content_name2_color,
        textDecoration: this.itemAvailable(i) ? '' : 'line-through'
      }
    },
  }
}
</script>

<style scoped>
.note {
  font-weight: 400;
  font-size: smaller;
}
.title-name {
  margin-bottom: 18px;
}
.option {
  margin-top: -32px;
}
.food-img {
  border-radius: 5px;
  object-fit: cover;
  position: relative;
}
.feature-icon-img {
  margin-left: 2px;
}
.feature-icon-desc {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemDetail.vue